import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  package as PackagePropType,
  layoutContext as LayoutContextPropType,
} from 'lib/CustomPropTypes';

import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import SlideshowTeasePicture from 'components/SlideshowTeasePicture';
import PackageTitle from 'components/PackageTitle';
import AIMS_FLAVORS from 'lib/aimsFlavors';

function image(item) {
  if (item.type === 'slideshow') {
    return (
      <SlideshowTeasePicture
        slides={item.item.slides}
        sizes={{
          s: 360, m: 230, l: 130, xl: 190,
        }}
      />
    );
  }
  return (
    <TeasePicture
      responsiveFlavors={{
        s: AIMS_FLAVORS.FOCAL_758x379,
        m: AIMS_FLAVORS.FOCAL_460x460,
        l: AIMS_FLAVORS.FOCAL_260x260,
        xl: AIMS_FLAVORS.FOCAL_380x380,
      }}
      type={item.type}
      computedValues={item.computedValues}
    />
  );
}

function getTease(content, metadata, vertical, isMobileOnlyComponent) {
  if (!content) return null;
  return (
    <TeaseCard
      content={content}
      {...metadata}
      {...content.metadata}
      size="large"
      vertical={vertical}
      isMobileOnlyComponent={isMobileOnlyComponent}
    >
      {image(content)}
    </TeaseCard>
  );
}

function TwoUp(props) {
  const {
    content,
    className = '',
    pkgClassName,
    vertical,
    isFirstLayout,
    alternateTitleFormat,
    isMobileOnlyComponent,
  } = props;

  if (!content || !(content.items && content.items[0])) return null;

  const {
    id, items, metadata = {}, packageIndex,
  } = content;

  const isFirstLayoutAndPackage = isFirstLayout && !packageIndex;
  const classes = classNames(
    pkgClassName,
    className,
    { 'two-up__accent-line': isFirstLayoutAndPackage },
    'tease-card--two-up',
  );

  return (
    <section
      className={classNames(classes)}
      data-packageid={id}
      data-test="two-up__section"
    >
      { metadata && metadata.title && (
        <PackageTitle
          metadata={metadata}
          alternateDisplayFormat={alternateTitleFormat}
        />
      )}
      <div className="two-up__articles">
        {getTease(items[0], metadata, vertical, isMobileOnlyComponent)}
        {getTease(items[1], metadata, vertical, isMobileOnlyComponent)}
        {/* check for ads */}
        {items[2] && getTease(items[2], metadata, vertical, isMobileOnlyComponent)}
      </div>
    </section>
  );
}

TwoUp.propTypes = {
  content: PackagePropType.isRequired,
  className: PropTypes.string,
  pkgClassName: PropTypes.string,
  vertical: PropTypes.string,
  isFirstLayout: PropTypes.bool,
  alternateTitleFormat: PropTypes.bool,
  isMobileOnlyComponent: PropTypes.bool,
};

TwoUp.defaultProps = {
  className: '',
  pkgClassName: 'pkg twoUp',
  vertical: '',
  isFirstLayout: false,
  alternateTitleFormat: false,
  isMobileOnlyComponent: false,
};

TwoUp.contextTypes = LayoutContextPropType;

export default TwoUp;
